import Vue from 'vue'
import Axios from './plugins/axios'
import './plugins/components'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import vueDebounce from 'vue-debounce'

Vue.config.productionTip = false

Vue.use(vueDebounce)
Vue.use(Axios, { store })

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
